import { Input } from '@chakra-ui/react';
import React from 'react';

interface TaskSearchBarProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  inputRef?: React.RefObject<HTMLInputElement>;
  onBlur?: () => void;
}

export const TaskSearchBar: React.FC<TaskSearchBarProps> = ({
  searchQuery,
  setSearchQuery,
  inputRef,
  onBlur,
}) => {
  return (
    <Input
      placeholder="Search tasks..."
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      width="200px"
      size="sm"
      ml={2}
      variant="ghost"
      background="transparent"
      ref={inputRef}
      onBlur={onBlur}
    />
  );
};
